import styled, { css } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

const printStyles = css`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media print {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
`

export const TableRow = styled.div<{
  $isTotal?: boolean
  $hasBorderTop?: boolean
  $columns?: '2col' | '4col'
}>`
  display: grid;
  grid-template-columns: 200px 1fr 50px 120px;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid
    ${({ $isTotal }) =>
      $isTotal ? cardisTheme.colors.secondary : cardisTheme.colors.borderLight};
  align-items: baseline;

  ${({ $isTotal }) =>
    $isTotal &&
    css`
      padding-top: 8px;
      border-top: 2px solid ${cardisTheme.colors.secondary};
      border-bottom: none;
    `}
`

export const TableLabel = styled.span<{ $isTotal?: boolean }>`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${({ $isTotal }) => ($isTotal ? '16px' : '14px')};
  font-weight: ${({ $isTotal }) => ($isTotal ? 500 : 400)};
  color: ${({ $isTotal }) =>
    $isTotal ? cardisTheme.colors.secondary : cardisTheme.colors.primary};

  @media print {
    ${printStyles}
  }
`

export const TableValue = styled.span<{
  $isTotal?: boolean
  $isNegative?: boolean
}>`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${({ $isTotal }) => ($isTotal ? '16px' : '14px')};
  font-weight: ${({ $isTotal }) => ($isTotal ? 600 : 400)};
  color: ${({ $isTotal, $isNegative }) =>
    $isTotal
      ? cardisTheme.colors.secondary
      : $isNegative
        ? cardisTheme.colors.textLight
        : cardisTheme.colors.textLight};
  text-align: right;

  @media print {
    ${printStyles}
  }
`

export const TableCurrency = styled.span<{ $isTotal?: boolean }>`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${({ $isTotal }) => ($isTotal ? '16px' : '14px')};
  font-weight: 400;
  color: ${({ $isTotal }) =>
    $isTotal ? cardisTheme.colors.secondary : cardisTheme.colors.textLight};
  text-align: right;

  @media print {
    ${printStyles}
  }
`

export const TablePercent = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 16px;
  font-weight: 400;
  color: ${cardisTheme.colors.textGray};
  text-align: right;

  @media print {
    font-size: 16px !important;
    color: ${cardisTheme.colors.textGray} !important;
    text-align: right !important;
    ${printStyles}
  }
`
